<template>
  <div class="ifisea">
    <sub-title :text="title" />
    <div class="seaform mt30">
      <div class="inp flex_start">
        <div>关键词：</div>
        <div class="text"><input type="text" v-model="seaobj.title" /></div>
      </div>
      <div class="inp flex_start">
        <div>发文字号：</div>
        <div class="text">
          <input type="text" v-model="seaobj.issue_number" />
        </div>
      </div>
      <div class="inp flex_start">
        <div>颁发单位：</div>
        <div class="text">
          <input type="text" v-model="seaobj.issue_unit" />
        </div>
      </div>
      <div class="inp flex_start">
        <div>效力级别：</div>
        <el-select
          :popper-append-to-body="false"
          v-model="seaobj.effect_level"
          placeholder="-请选择-"
          class="sele1"
        >
          <el-option
            v-for="item in xllist"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="inp flex_start">
        <div>时效性：</div>
        <el-select
          :popper-append-to-body="false"
          v-model="seaobj.timeliness"
          placeholder="-请选择-"
          class="sele1"
        >
          <el-option
            v-for="item in sxlist"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="inp2">
        <el-col :span="11">
          <el-date-picker
            class="itm"
            v-model="seaobj.start_date"
            type="date"
            :clearable="false"
            value-format="timestamp"
            placeholder="结束时间"
          />
        </el-col>
        <el-col :span="2" class="text_center line40">-</el-col>
        <el-col :span="11">
          <el-date-picker
            class="itm"
            v-model="seaobj.end_date"
            type="date"
            :clearable="false"
            value-format="timestamp"
            placeholder="结束时间"
          >
          </el-date-picker>
        </el-col>
      </div>
      <div class="searchbtn" @click="subsearch">搜索</div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  props: {
    title: {
      type: String,
      default: "法规检索",
    },
  },
  components: {
    subTitle,
  },
  data: () => ({
    xllist: [
      { value: "宪法", label: "宪法" },
      { value: "法律", label: "法律" },
      { value: "行政法规", label: "行政法规" },
      { value: "地方性法规", label: "地方性法规" },
      { value: "自治条例和单行条例", label: "自治条例和单行条例" },
      { value: "部门规章", label: "部门规章" },
      { value: "地方规章", label: "地方规章" },
    ],
    sxlist: [
      { value: "现行有效", label: "现行有效" },
      { value: "现已失效", label: "现已失效" },
      { value: "尚未生效", label: "尚未生效" },
      { value: "已修订", label: "已修订" },
    ],
    seaobj: {},
  }),
  methods: {
    subsearch() {
      let data = {
        ...this.seaobj,
      };
      this.$store.commit("jpcol/uptlsea", data);
      this.$router.push({
        path: "/jpcol/tiaoli/tiaoliifyul",
        query:{search:1}
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ifisea {
  width: 100%;
  height: 100%;
  padding: 23px 12px;
  background: #ffffff;
  box-shadow: 0px 2px 15px 0px rgba(1, 1, 1, 0.1);
  .seaform {
    .inp {
      width: 100%;
      height: 40px;
      padding-left: 10px;
      padding-bottom: 1px;
      margin-bottom: 20px;
      font-size: 14px;
      color: #333333;
      border-radius: 2px;
      border: 1px solid #ececec;
      .text {
        flex: 1;
        input {
          width: 100%;
          height: 36px;
          border: none;
          outline: none;
        }
      }

      .sele1 {
        flex: 1;
      }
      ::v-deep .el-input__inner {
        border: none;
        height: 36px;
      }

      ::v-deep .el-select-dropdown__wrap {
        max-height: 200px;
      }
      ::v-deep .el-input__icon {
        display: none;
      }
    }
    .inp2 {
      margin-bottom: 20px;
      width: 100%;
      height: 40px;
      font-size: 14px;
      color: #333333;
      ::v-deep .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 100%;
      }
      ::v-deep .el-input--prefix .el-input__inner {
        padding-right: 10px;
      }
      .line40 {
        line-height: 40px;
      }
    }
    .searchbtn {
      width: 150px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      margin: 0 auto;
      background: #0465ea;
      border-radius: 18px;
      font-size: 16px;
      color: #ffffff;
    }
  }
}
</style>